import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

// react-routers components
import { Link } from "react-router-dom";

// @mui material components
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDDialog from "components/MDDialog";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import ProfileInfoCard from "examples/Cards/InfoCards/ProfileInfoCard";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import ComplaintsList from "examples/Lists/ComplaintsList";
import OrdersList from "examples/Lists/OrdersList";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Overview page components
import Header from "layouts/client-management-details/components/Header";

import {
  activateDeactivateClient,
  clientUpdating,
  getClientSingle,
} from "actions/clientActions";
import { getProfile } from "actions/userActions";

import MDActionConfigurator from "components/MDActionConfigurator";

function Overview() {
  const configuratorRef = useRef(null);
  const dispatch = useDispatch();
  const { id } = useParams();
  const [currentState, setCurrentState] = useState("");
  const [currentData, setCurrentData] = useState({
    _id: "",
    name: "",
    email: "",
    phone: "",
    idNumber: "",
    date_of_birth: "",
    profile_image: "",
    active: false,
    products: [],
    complaints: [],
  });

  const getMe = useSelector((state) => state.getMe);
  const { me } = getMe;

  useEffect(() => {
    // if (me?.length === 0) {
    dispatch(getProfile());
    // }
  }, [dispatch]);

  const singleClient = useSelector((state) => state.singleClient);
  const { clientSingle } = singleClient;
  console.log(
    "🚀 ~ file: index.js:71 ~ Overview ~ clientSingle:",
    clientSingle
  );

  useEffect(() => {
    dispatch(getClientSingle(id));
  }, [dispatch, clientSingle?.length, id]);

  const handleToggleBackdrop = (item, state) => {
    // item.date_of_birth = ""; //to be removed on d
    setCurrentData(item);
    setCurrentState(state);
    if (configuratorRef.current) {
      configuratorRef.current.handleToggleConfigurator();
    }
  };

  const handleSubmitClient = (e) => {
    if (currentState === "edit") {
      dispatch(clientUpdating(currentData?._id, e));
    } else {
      dispatch(clientCreate(e));
    }
    handleToggleBackdrop({}, "");
  };

  const handleAgreeActivateDeactivate = () => {
    dispatch(activateDeactivateClient(id, { active: !clientSingle?.active }));
  };

  return (
    <DashboardLayout>
      <DashboardNavbar title={`${clientSingle?.name}'s Details`} />
      <MDBox mb={2} />
      <Header info={clientSingle}>
        <MDBox mt={5} mb={3}>
          {(me?.role === "super_admin" || me?.role === "admin") && (
            <MDBox width="100%" px={4}>
              <MDBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={0.5}
                // px={2}
              >
                <MDTypography
                  variant="h6"
                  fontWeight="medium"
                  textTransform="capitalize"
                >
                  Account Settings
                </MDTypography>
              </MDBox>
              <Grid container spacing={1} mb={5}>
                <Grid item xs={12} md={3} xl={3}>
                  <MDBox lineHeight={1}>
                    <MDBox
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      mb={0.5}
                    >
                      <MDBox width="80%">
                        <MDTypography
                          variant="button"
                          fontWeight="regular"
                          sx={{
                            color: ({ palette: { text, grey } }) =>
                              text.darkAccent,
                          }}
                        >
                          Edit Account Information
                        </MDTypography>
                      </MDBox>
                      <MDBox>
                        <MDTypography
                          component={Link}
                          to=""
                          variant="body2"
                          sx={{
                            color: ({ palette: { text, grey } }) =>
                              text.darkAccent,
                          }}
                          onClick={() =>
                            handleToggleBackdrop(clientSingle, "edit")
                          }
                        >
                          <Tooltip title="Edit Client Account" placement="top">
                            <Icon
                              fontSize="medium"
                              sx={{
                                color: ({ palette: { text, grey } }) =>
                                  text.darkAccent,
                                marginLeft: 2,
                                marginRight: 2,
                              }}
                            >
                              edit
                            </Icon>
                          </Tooltip>
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                  <MDBox lineHeight={1}>
                    <MDBox
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      mb={0.5}
                    >
                      <MDBox width="80%">
                        <MDTypography
                          variant="button"
                          fontWeight="regular"
                          sx={{
                            color: ({ palette: { text, grey } }) =>
                              text.darkAccent,
                          }}
                        >
                          Account is{" "}
                          {clientSingle?.active ? " Active" : " Inactive"}
                        </MDTypography>
                      </MDBox>
                      <MDBox>
                        <MDDialog
                          title={`${
                            clientSingle?.active ? "Deactivate " : "Activate "
                          } ${clientSingle?.name}'s Account`}
                          details={`Are You sure you want to ${
                            clientSingle?.active ? " Deactivate " : " Activate "
                          } ${clientSingle?.name}'s account?`}
                          onAgree={handleAgreeActivateDeactivate}
                          customButton={
                            <Switch checked={clientSingle?.active} />
                          }
                        />
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>
          )}
          <Divider />
          <Grid container spacing={1}>
            <Grid item xs={12} md={4} xl={4} sx={{ display: "flex" }}>
              <MDBox width="100%" px={4}>
                <ProfileInfoCard
                  title="Client Account Information"
                  currentInfo={clientSingle}
                  id={id}
                  active={clientSingle?.active}
                  info={{
                    fullName: clientSingle?.name,
                    mobile: clientSingle?.phone,
                    email: clientSingle?.email,
                    idNumber: clientSingle?.idNumber,
                    dob: moment(clientSingle?.date_of_birth).format(
                      "DD/MM/YYYY"
                    ),
                    joined: moment(clientSingle?.created_at).fromNow(),
                  }}
                  action={{ route: "", tooltip: "Edit Profile" }}
                  shadow={false}
                />
              </MDBox>
              <Divider orientation="vertical" sx={{ mx: 1 }} />
            </Grid>
            <Grid item xs={12} md={4} xl={4}>
              <OrdersList
                title={
                  clientSingle?.name
                    ? `${clientSingle?.name}'s Product Orders`
                    : "Product Orders"
                }
                action={{
                  type: "internal",
                  label: "View Details",
                }}
                orders={clientSingle?.orders}
                shadow={false}
              />
            </Grid>
            <Grid item xs={12} md={4} xl={4}>
              <MDBox>
                <ComplaintsList
                  title={
                    clientSingle?.name
                      ? `${clientSingle?.name}'s Complaints`
                      : "Complaints"
                  }
                  action={{
                    type: "internal",
                    label: "View Details",
                  }}
                  complaints={clientSingle?.complaints}
                  shadow={false}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
      </Header>

      <MDActionConfigurator
        ref={configuratorRef}
        title="Client Config"
        onCompleteConfig={handleSubmitClient}
        data={[
          {
            keyType: "_id",
            valueType: currentData?._id,
          },
          {
            labelType: "Name",
            placeholderType: "Enter Name",
            dataType: "text",
            keyType: "name",
            valueType: currentData?.name,
          },
          {
            labelType: "Email",
            placeholderType: "Enter Email",
            dataType: "email",
            keyType: "email",
            valueType: currentData?.email,
          },
          {
            labelType: "Phone",
            placeholderType: "Enter Phone",
            dataType: "phone",
            keyType: "phone",
            valueType: currentData?.phone,
          },
          {
            labelType: "National ID Number",
            placeholderType: "Enter National ID Number",
            dataType: "text",
            keyType: "idNumber",
            valueType: currentData?.idNumber,
          },
          {
            labelType: "D.O.B",
            placeholderType: "Choose Date of Birth",
            dataType: "date",
            keyType: "date_of_birth",
            valueType: currentData?.date_of_birth,
          },
          {
            labelType: "Profile Image",
            placeholderType: "Enter Profile Image",
            dataType: "image",
            keyType: "profile_image",
            valueType: currentData?.profile_image,
          },
          // {
          //   labelType: "Active",
          //   placeholderType: "Active",
          //   dataType: "active",
          //   keyType: "active",
          //   valueType: currentData?.active,
          // },
        ]}
        state={currentState}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default Overview;
